import React from 'react';

interface RemoteImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}

const RemoteImage: React.FC<RemoteImageProps> = ({ src, ...props }) => {
  const baseUrl = 'https://assets.malomfesztival.org';
  const fullSrc = `${baseUrl}${src}`;

  return <img src={fullSrc} {...props} />;
};

export default RemoteImage;
